import { createCastManagerImpl } from './internal/CastManagerImpl';
import { CastManager } from './CastManager';
import { CastPlayer } from './CastPlayer';
import { CastPlaybackOptions } from './CastPlaybackOptions';

const version = '__buildVersion__';

export { createCastManagerImpl, CastPlayer, CastManager, CastPlaybackOptions, version };
